export default __webpack_public_path__ + "static/media/music-background.9e3066ac.png";